/*----------------------------------
- CATALOG (SSOT): HOME DEMO WINDOW COPY
----------------------------------*/

/**
 * The words of Home's product tour (docs/mockups/website-home-v3.html, `section.demo`): the window's names, its five tabs
 * and the persona switch. The screenshots of tabs 2 to 5 are `components/home/demoScreens.ts`; the Browse frame drawn
 * around the real table of tab 1 reads `HOME_BROWSE_COPY` in `homeCopy.ts`.
 *
 * @docs docs/features/website-landing-experience
 * @adr  ADR-0110
 * @rule The first tab is the real public table (ten rows of the bare `/domains` search, ADR-0028); the four others are
 *       sample screenshots under the "Sample screen" tag, never real names.
 */

/*----------------------------------
- DEPENDANCES
----------------------------------*/

import type { SpriteIconName } from '@/client/components/ui/icon/Icon';
import type { HomePersona } from '@uniquedomains/components/marketing/demo-window/PersonaSwitch';

import type { HomeDemoSampleTabId } from '@/client/pages/landing/components/home/demoScreens';

/*----------------------------------
- TYPES
----------------------------------*/

export type HomeDemoTabId = 'find' | HomeDemoSampleTabId;

export type HomeDemoTab = { id: HomeDemoTabId; label: string; icon: SpriteIconName };

/*----------------------------------
- CATALOG (SSOT)
----------------------------------*/

/** The tabs in the mock's order; `find` holds the live table. Icons are the sprite's nearest to the mock's lucide set. */
export const HOME_DEMO_TABS: readonly HomeDemoTab[] = [
    { id: 'find', label: 'Find a name', icon: 'search' },
    { id: 'check', label: 'Check before you buy', icon: 'shield' },
    { id: 'watch', label: 'Never miss a name', icon: 'bell' },
    { id: 'trend', label: 'Spot trends', icon: 'trending-up' },
    { id: 'market', label: 'Read the market', icon: 'chart-bar' },
];

export const HOME_DEMO_COPY = {
    sectionLabel: 'What you can do in Unique Domains',
    tabsLabel: 'Product tour',
    sampleTag: 'Sample screen',
    personaLabel: 'Show the product as',
    personaLabels: { investor: 'Investor', founder: 'Founder' } satisfies Record<HomePersona, string>,
} as const;
